// utils/apiClient.js
import axios from "axios";
import decryptResponse from "./decrypt";

const BASE_URL = process.env.REACT_APP_API_IP || "";

const apiClient = async (method, url, data = {}, config = {}) => {
  try {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;

    const options = {
      method,
      url: `${BASE_URL}${url}`, // ✅ always prepend base URL
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(config.headers || {}),
      },
      ...(method.toLowerCase() === "get" ? { params: data } : { data }),
    };

    const response = await axios(options);

    if (response.data?.encrypted) {
      return { success: true, data: decryptResponse(response.data.encrypted), status: response.status };
    }

    return { success: true, data: response.data, status: response.status };

  } catch (error) {
    let decryptedError = null;

    if (error.response?.data?.encrypted) {
      decryptedError = decryptResponse(error.response.data.encrypted);
    } else if (error.response?.data?.error?.encrypted) {
      decryptedError = decryptResponse(error.response.data.error.encrypted);
    }

    return {
      success: false,
      status: error.response?.status,
      error: decryptedError || error.response?.data || error.message,
    };
  }
};


export default apiClient;
